module.exports = __webpack_public_path__ + "img/dengzhou.4ac3d395.png";